import React, { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import { Container, Card } from 'react-bootstrap';

import Header from '~/Components/Header/Header';
import { extrairMensagemErro } from '~/Utils/Helpers';
import {
  listarAcordosNaoConcretizados,
  listarCobradores,
  listarEmpreendimentos,
} from './services/acordosNaoConcretizadosService';
import FiltrosAcordosNaoConcretizados from './components/FiltrosAcordosNaoConcretizados';
import TabelaAcordosNaoConcretizados from './components/TabelaAcordosNaoConcretizados';

// W-0804 — Acordos de cobrança não concretizados (Relatórios > Cobrança). Read-only.
// A regra de "não concretizado" (pré-filtro acordo+2 + crivo de dia útil) é 100% backend;
// o front só envia os filtros e exibe o resultado. httpService já desembrulha .data.
const MSG_VAZIO = 'Nenhum registro encontrado!';
const MSG_PERIODO = 'Período de inativação é obrigatório.';

const filtrosIniciais = {
  data_inicial: '',
  data_final: '',
  cobrador: null,
  empreendimento: null,
  tipo_titulo: 2, // Todos (default)
  analitico: true, // Analítico (default)
  foco: 0, // Cobradores (default)
};

const AcordosNaoConcretizados = () => {
  const [filtros, setFiltros] = useState(filtrosIniciais);
  const [cobradores, setCobradores] = useState([]);
  const [empreendimentos, setEmpreendimentos] = useState([]);

  const [linhas, setLinhas] = useState([]);
  const [filtrosAplicados, setFiltrosAplicados] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [buscou, setBuscou] = useState(false);

  const seqRef = useRef(0);

  // Mount: cobradores (escopo no backend) + empreendimentos.
  useEffect(() => {
    let ativo = true;
    listarCobradores()
      .then((res) => ativo && setCobradores(res || []))
      .catch((err) =>
        toast.error(extrairMensagemErro(err, 'Erro ao carregar cobradores.'))
      );
    listarEmpreendimentos()
      .then((res) => ativo && setEmpreendimentos(res || []))
      .catch(() => {});
    return () => {
      ativo = false;
    };
  }, []);

  const handleBuscar = () => {
    if (!filtros.data_inicial || !filtros.data_final) {
      toast.error(MSG_PERIODO);
      return;
    }
    const seq = ++seqRef.current;
    setCarregando(true);
    const params = {
      dataInicial: filtros.data_inicial,
      dataFinal: filtros.data_final,
      cobrador: filtros.cobrador || null,
      empreendimento: filtros.empreendimento || null,
      tipoTitulo: filtros.tipo_titulo,
      analitico: filtros.analitico,
      foco: filtros.foco,
    };
    listarAcordosNaoConcretizados(params)
      .then((res) => {
        if (seq !== seqRef.current) return;
        const lista = Array.isArray(res) ? res : [];
        setLinhas(lista);
        setFiltrosAplicados({ ...filtros });
        setBuscou(true);
        if (lista.length === 0) toast.info(MSG_VAZIO);
      })
      .catch((err) => {
        if (seq !== seqRef.current) return;
        toast.error(extrairMensagemErro(err, 'Erro ao gerar o relatório.'));
        setLinhas([]);
        setBuscou(true);
      })
      .finally(() => {
        if (seq === seqRef.current) setCarregando(false);
      });
  };

  const handleLimpar = () => {
    setFiltros(filtrosIniciais);
    setLinhas([]);
    setFiltrosAplicados(null);
    setBuscou(false);
  };

  const temResultado = linhas.length > 0;
  const aplicadoAnalitico = filtrosAplicados ? filtrosAplicados.analitico : true;
  const aplicadoFoco = filtrosAplicados ? filtrosAplicados.foco : 0;

  return (
    <>
      <Header title="Acordos de cobrança não concretizados" />

      <Container fluid className="mt-3">
        <Card className="mb-3">
          <Card.Body>
            <FiltrosAcordosNaoConcretizados
              filtros={filtros}
              onChange={setFiltros}
              cobradores={cobradores}
              empreendimentos={empreendimentos}
              carregando={carregando}
              onBuscar={handleBuscar}
              onLimpar={handleLimpar}
            />
          </Card.Body>
        </Card>

        <Card>
          <Card.Body>
            {carregando && (
              <div className="text-center text-secondary p-3">Carregando...</div>
            )}

            {!carregando && buscou && temResultado && (
              <>
                <div className="mb-2 text-secondary" style={{ fontSize: '0.9rem' }}>
                  {filtrosAplicados && (
                    <span className="mr-3">
                      Período: {filtrosAplicados.data_inicial} →{' '}
                      {filtrosAplicados.data_final}
                    </span>
                  )}
                  <span>Registros: {linhas.length}</span>
                </div>
                <TabelaAcordosNaoConcretizados
                  linhas={linhas}
                  analitico={aplicadoAnalitico}
                  foco={aplicadoFoco}
                />
              </>
            )}

            {!carregando && buscou && !temResultado && (
              <div className="text-center text-secondary p-3">{MSG_VAZIO}</div>
            )}

            {!carregando && !buscou && (
              <div className="text-center text-secondary p-3">
                Informe o período e clique em Gerar.
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default AcordosNaoConcretizados;
